calendar = function (id) {

	var objCalendar = {};
	var objDialog = dialog();
	var domObject = dom();
	var objDate = date();

	objCalendar.dateTimePicker = function() {
		/* date picker for start and ending dates on edit form */
		$('#event-edit-startDate,#event-edit-endDate').datepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: 'yy-mm-dd'
		});

		$('#recurring-endOn-edit-daily,#recurring-endOn-edit-weekly,#recurring-endOn-edit-monthly,#recurring-endOn-edit-yearly').datetimepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: 'yy-mm-dd',
      timeFormat: 'HH:mm:ss',
  		showSecond: false,
      showMillisec: false,
      showMicrosec: false,
      showTimezone: false,
      stepMinute: 5,
      controlType: 'select'
		});

		$('#event-edit-startTime, #event-edit-endTime').timepicker({
      timeFormat: 'HH:mm:ss',
  		showSecond: false,
      showMillisec: false,
      showMicrosec: false,
      showTimezone: false,
      stepMinute: 5,
      controlType: 'select'
		});
	};

	/**
	 * Update a calendar event
	 *
	 * @param int id	holds the event id
	 * @param timestamp startDate The start date of the event
	 * @param timestamp endDate the end date of the event (default 0)
	 */
	objCalendar.updateEvent = function(id, startDate, endDate, isTime) {
		/* format data for ajax */
		var updateData = {
			startDate : startDate,
			endDate : endDate,
			isTime : isTime
		};

		/* update event using puts */
		$.ajax({
			url: '/admin/calendar:' + id + '.json',
			type: 'put',
			data: updateData,
			success: function(result){
				if (result.status <= 0)
				{
					console.error('Update Failed');
				}
			}
		});
	};

	/**
	 * Refresh the calendar to show new or updated events
	 */
	objCalendar.refreshCalendar = function() {
		$('#calendar').fullCalendar('refetchEvents');
	};

	/**
	 * Adds a new event
	 *
	 * It first checks to see if the user is adding by selecting a date cell
	 * and dragging to another cell. If so then we turn the start date given to us
	 * from the calendar into a readable date and make it the value for the startDate field.
	 * we do the same if the endDate value is not 0.
	 *
	 * if the user clicked on the add event link instead then the dialog will be created
	 * without the startDate and endDate being pre-populated. When the user inputs their data
	 * and clicks on add event it firsts checks if the status returned by the ajax is greater than 0
	 * if so this means the form validated and we added the event. If its not then we have validation
	 * errors which we display to the user to fix before submitting again.
	 *
	 * @param timestamp startDate	holds the startDate if from selectable add new event else undefined
	 * @param timestamp endDate		holds the endDate if from a selectable event else undefined
	 * @param boolean allDay		holds whether this is an all day event or not
	 *
	 * @todo implement the allDay
	 */
	objCalendar.addEvent = function(startDate, endDate, allDay) {

		$('#calendar-dialog div.calendar-color-boxes').children('div').removeClass('.calendar-color-selected');

		/* checks if adding the event based on a selected range by user (meaning they drag selected their date range on the calendar) */
		if (+startDate !== 0 && startDate !== undefined) {
			/* convert timestamp to javascript by multiplying by 1000 so its in milliseconds not seconds */
			var sdate = new Date(startDate * 1000);

			$('#event-details-startDate').val(sdate.getFullYear() + '-' + (sdate.getMonth() + 1) + '-' + sdate.getDate());

			/* if this is not an all day event then we uncheck allDay and show the start and end times form */
			if (!allDay) {
				$('#event-details-allDay').removeAttr('checked');
				$('#event-times').show();
				$('#event-details-startTime').val(sdate.getHours() + ':' + sdate.getMinutes() + ':' + sdate.getSeconds());
			}

			/* if we have an end date then we need to add it to the endDate field */
			if(+endDate !== 0 && endDate !== undefined) {
				var edate = new Date(endDate * 1000);
				$('#event-details-endDate').val(edate.getFullYear() + '-' + (edate.getMonth() + 1) + '-' + edate.getDate());

				if (!allDay) {
					$('#event-details-allDay').removeAttr('checked');
					$('#event-times').show();
					$('#event-details-startTime').val(edate.getHours() + ':' + edate.getMinutes() + ':' + edate.getSeconds());
				}
			}
		}

		/* create a dialog box for the add event form */
		var dialog = objDialog.createDOMDialog('calendar-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Save Event': function() {
					var type = '';
					// Retrieve the allDay value. If not checked we return ''.
					var allDay = $('#event-details-allDay:checked').length ? $('#event-details-allDay').val() : '';
					if (allDay === 'yes') {
						allDay = 1;
					} else if (allDay === '') {
						allDay = 0;
					}

					// Retrieve the color based on which inner div has the class calendar-color-selected.
					var color;
					if ($('#calendar-dialog .calendar-color-selected').length === 1) {
						color = $('#calendar-dialog .calendar-color-selected').parent().attr('title');
					} else {
						color = '00CED1';
					}
					$('#calendar-dialog .calendar-color-selected').attr('class', '');

					// First get data from the form.
					switch($('#recurring-type').val()) {
					case 'none':
						repeatOn = '';
						repeatBy = '';
						break;
					case 'daily':
						type = 'daily';
						repeatOn = '';
						repeatBy = '';
						break;
					case 'weekly':
						type = 'weekly';
						repeatOn = $('#recurring-repeat-on-weekly').val();
						repeatBy = '';
						break;
					case 'monthly':
						type = 'monthly';
						repeatOn = '';
						repeatBy = $('#recurring-repeat-by-monthly').val();
						break;
					case 'yearly':
						type = 'yearly';
						repeatOn = '';
						repeatBy = '';
						break;
					}

					// validate the necessary fields
					function isValidEndDate() {
						startDate = new Date($('#event-details-startDate').val());
						endDate = new Date($('#event-details-endDate').val());

						if (endDate.getTime() < startDate.getTime()) {
							return false;
						}
						return true;
					}

					function isValidTime() {
						var allDay = $('#event-details-allDay:checked').length ? $('#event-details-allDay').val() : '';
						if ((allDay === 'yes')||((allDay === '') && ($('#event-details-startTime').val() !== '') && ($('#event-details-endTime').val() !== ''))) {
							return true;
						} else if ((allDay === '') && (($('#event-details-startTime').val() === '') || ($('#event-details-endTime').val() === ''))) {
							return false;
						}
					}

					$.validity.start();
					$('#event-details-title').require();
					$('#event-details-description').maxLength(1024);
					$('#event-details-startDate').require();
					$('#event-details-endDate').assert(isValidEndDate, 'The End Date cannot be less than the Start Date.');
					$('#event-details-allDay').assert(isValidTime, 'The Start and End times cannot be empty.');
					var result = $.validity.end();

					if (result.valid) {
						var formData = {
							title : $('#event-details-title').val(),
							description : $('#event-details-description').val(),
							startDate : $('#event-details-startDate').val(),
							endDate : $('#event-details-endDate').val(),
							startTime : $('#event-details-startTime').val(),
							endTime : $('#event-details-endTime').val(),
							allDay : allDay,
							color : color,
							recurringType : $('#recurring-type').val(),
							recurringRepeat : $('#recurring-repeat-' + type).val(),
							recurringEndType : $('input[name=endRecurring-' + type + ']:checked').val(),
							recurringEndAfter : $('#recurring-endAfter-' + type).val(),
							recurringEndOn : $('#recurring-endOn-' + type).val(),
							repeatOn : repeatOn,
							repeatBy : repeatBy
						};

						/* clear errors before we submit again */
						objCalendar.clearErrors();

						/* post data to controller CalendarController.php to process and save the data */
						$.ajax({
							url: '/admin/calendar.json',
							type: 'post',
							data: formData,
							success: function(result){
								if (result.status > 0) {
									/* refresh the calendar to show the add */
									objCalendar.refreshCalendar();

									/* close the dialog */
									$('#calendar-dialog').dialog('close');

								} else {

									/* validation errors so show them */
									$.each(result.errors, function(field, message) {
										/* toggle the error class for the field */
										$('#event-details-' + field).addClass('calendar-field-input-error');
										$('#' + field + '-failed').addClass('calendar-error');
										$('#' + field + '-failed').show();

										/* add all errors to the error field */
										$.each(message, function(k, error) {
											$('#' + field + '-failed').append($('<li></li>').html(error));
										});
									});
								}
							}
						});
					}

				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			/* cleanup the form */
			defaults.close = function(event, ui) {
				objCalendar.clearErrors();
				objCalendar.cleanDialog();
			};

			/* show the form with all the above settings */
			$(dialog).dialog(defaults);
		});
	};

	/**
	 * adds a loading mask to the calendar when loading event data
	 *
	 * @param string id holds the id of the calendar div to put the mask on
	 */
	objCalendar.addMask = function(id) {
		$('#' + id).mask('loading');
	};

	/**
	 * removes the loading mask from the calendar after done loading events
	 *
	 * @param string id holds the id of the calendar div to put the mask on
	 */
	objCalendar.unMask = function(id) {
		$('#' + id).unmask();
	};

	/**
	 * Display edit form/update event
	 *
	 * It first retrieves the event based on the passed in id which we get from the calendar.
	 * It will then create a dialog and set the values of the form items to the ones received
	 * from the database. When done editing the user will click update and it will send an ajax
	 * request by PUT to udpate the event details.
	 *
	 * The edit form also has a delete button which allows users to delete their calendar events.
	 * When they click the button and this is a recurring event it will ask them if they want to
	 * delete just this event or all recurring events within this instance. If its not recurring
	 * it will just give them a dialog asking them if they want to delete this event.
	 *
	 * @param int id holds the id of the event we got from the click event handler
	 *
	 */
	objCalendar.editEvent = function(id) {

		/* retrieve data */
		params = {
			display : 'ajaxEdit',
			id : id
		};

		$.ajax({
			url: '/admin/calendar',
			data: params,
			type: 'GET',
			beforeSend: function() {
				objCalendar.addMask('calendar-edit-dialog');
			},
			complete: function() {
				objCalendar.unMask('calendar-edit-dialog');
			},
			success: function(data) {
				$('#calendar-edit-dialog').contents().remove();
				$('#calendar-edit-dialog').html(data);
				objCalendar.dateTimePicker();
			}
		});

		/* create a dialog box for the edit event form */
		var dialog = objDialog.createDOMDialog('calendar-edit-dialog', function(dialog, defaults) {
			defaults.buttons = {
				'Update Event': function() {

					var id = $('#event-edit-id').val();

					var type = '';

					/* retrieve the allDay value. If not checked we return '' */
					if ($('#event-edit-allDay').is(':checked')) {
						allDay = 1;
					} else {
						allDay = 0;
					}


					/* retrieve the color based on which inner div has the class calendar-color-selected */
					var color = $('.calendar-color-selected').parent().attr('title');

					/* first get data from the form */
					switch($('#edit-recurring-type').val()) {
					case 'none':
						repeatOn = '';
						repeatBy = '';
						break;
					case 'daily':
						type = 'daily';
						repeatOn = '';
						repeatBy = '';
						break;
					case 'weekly':
						type = 'weekly';
						repeatOn = $('#recurring-repeat-on-edit-weekly').val();
						repeatBy = '';
						break;
					case 'monthly':
						type = 'monthly';
						repeatOn = '';
						repeatBy = $('#recurring-repeat-by-edit-monthly').val();
						break;
					case 'yearly':
						type = 'yearly';
						repeatOn = '';
						repeatBy = '';
						break;
					}

					// validate the necessary fields
					function isValidEndDate() {
						startDate = new Date($('#event-edit-startDate').val());
						endDate = new Date($('#event-edit-endDate').val());
						if (endDate.getTime() < startDate.getTime()) {
							return false;
						}
						return true;
					}

					function isValidTime() {
						var allDay = $('#event-edit-allDay:checked').length ? $('#event-edit-allDay').val() : '';
						if ((allDay === 'yes')||((allDay === '') && ($('#event-edit-startTime').val() !== '') && ($('#event-edit-endTime').val() !== ''))) {
							return true;
						} else if ((allDay === '') && (($('#event-edit-startTime').val() === '') || ($('#event-edit-endTime').val() === ''))) {
							return false;
						}
					}

					$.validity.start();
					$('#event-edit-title').require();
					$('#event-edit-description').maxLength(1024);
					$('#event-edit-startDate').require();
					$('#event-edit-endDate').assert(isValidEndDate, 'The End Date cannot be less than the Start Date.');
					$('#event-details-allDay').assert(isValidTime, 'The Start and End times cannot be empty.');
					var result = $.validity.end();

					if (result.valid) {

						// First get data from the form.
						var formData = {
							fullUpdate : 1,
							title : $('#event-edit-title').val(),
							description : $('#event-edit-description').val(),
							startDate : $('#event-edit-startDate').val(),
							endDate : $('#event-edit-endDate').val(),
							startTime : $('#event-edit-startTime').val(),
							endTime : $('#event-edit-endTime').val(),
							allDay : allDay,
							color : color,
							recurringType : $('#edit-recurring-type').val(),
							recurringRepeat : $('#recurring-repeat-edit-' + type).val(),
							recurringEndType : $('input[name=endRecurring-edit-' + type + ']:checked').val(),
							recurringEndAfter : $('#recurring-endAfter-edit-' + type).val(),
							recurringEndOn : $('#recurring-endOn-edit-' + type).val(),
							repeatOn : repeatOn,
							repeatBy : repeatBy
						};

						// Clear errors before we submit again.
						objCalendar.clearErrors();

						// Put data to CalendarController.php so that it can update the data.
						$.ajax({
							url: '/admin/calendar:' + id + '.json',
							type: 'put',
							data: formData,
							success: function(result){
								if (result.status > 0) {
									console.log('Event Updated Successful');
									objCalendar.refreshCalendar();
									$('#calendar-edit-dialog').dialog('close');

								} else {

									// Validation errors so show them.
									$.each(result.errors, function(field, message) {
										// Toggle the error class for the field.
										$('#event-edit-' + field).addClass('calendar-field-input-error');
										$('#edit-' + field + '-failed').addClass('calendar-error');
										$('#edit-' + field + '-failed').show();

										// Add all errors to the error field.
										$.each(message, function(k, error) {
											$('#edit-' + field + '-failed').append($('<li></li>').html(error));
										});
									});
									console.log('Validation Failed');
								}
							}
						});
					}
				},
				Delete: function() {
					/* create a warning dialog to warn them about their delete */
					var dialog = objDialog.createBasicWarningDialog('remove-event', function(dialog, defaults) {

						/* get the ids of the event */
						var id = $('#event-edit-id').val();
						var title = $('#event-edit-title').val();
						var recurringId = $('#event-edit-recurring-id').val();

						/* ask the user if they want to remove the event */
						$(dialog).attr('title','Delete Event');
						$(dialog).append('Are you sure you want to remove <span class="strong">'+ title + '</span> event?</span>');
						defaults.buttons = {
							'Delete Event': function() {
								$.ajax({
									url: '/admin/calendar:' + id,
									type: 'DELETE',
									success: function(){

										/* refresh the calendar to show the add */
										objCalendar.refreshCalendar();
										objCalendar.closeDialogs();

									}
								});
							},
							Cancel: function() {
								$(this).dialog('close');
							}
						};

						/* show the dialog with the above settings */
						$(dialog).dialog(defaults);

					});
				},
				Cancel: function() {
					$(this).dialog('close');
				}
			};
			/* cleanup the form */
			defaults.close = function(event, ui) {
				objCalendar.clearErrors();
				objCalendar.cleanDialog();
			};
			/* show the dialog with the above settings */
			$(dialog).dialog(defaults);
			$(dialog).focus();
		});
	};

	/**
	 * closes the edit form dialog and warning dialog
	 */
	objCalendar.closeDialogs = function() {
		$('#calendar-edit-dialog').dialog('close');
		$('#curriculog-dialog-remove-event-warning').dialog('close');
	};

	/* removes values from form fields */
	objCalendar.cleanDialog = function() {

		$('input[id^="event-details"]').each(function(index) {
			$(this).val('');
		});

		$('textarea[id^="event-details"]').each(function(index) {
			$(this).val('');
		});

		$('input[id^="event-edit"]').each(function(index) {
			$(this).val('');
		});

		$('textarea[id^="event-edit"]').each(function(index) {
			$(this).val('');
		});

		/* this will also remove allDay value so add it back in */
		$('#event-details-allDay').val('yes');
		$('#event-edit-allDay').val('yes');

		/* this will reset the recurring options */
		$('select[name="recurringType"]').val('none');
		$('select[name="recurringRepeat-edit-daily"] option:selected, select[name="recurringRepeat-edit-weekly"] option:selected, select[name="recurringRepeat-edit-monthly"] option:selected, select[name="recurringRepeat-edit-yearly"] option:selected').removeAttr('selected');
		$('select[name="recurringRepeatOn-edit-weekly"] option:selected, select[name="recurringRepeatBy-edit-monthly"] option:selected').removeAttr('selected');
		$('input[name="endRecurring-edit-daily"], input[name="endRecurring-edit-weekly"], input[name="endRecurring-edit-monthly"], input[name="endRecurring-edit-yearly"]').removeAttr('checked');
		$('input[name="endAfter-edit-daily"], input[name="endAfter-edit-weekly"], input[name="endAfter-edit-monthly"], input[name="endAfter-edit-yearly"]').val('');
		$('input[name="endOn-edit-daily"], input[name="endOn-edit-weekly"], input[name="endOn-edit-monthly"], input[name="endOn-edit-yearly"]').val('');

		// reset visibility of recurring sections
		$('.recurring-edit').removeAttr('style');

	};

	/* removes error classes */
	objCalendar.clearErrors = function() {
		$('ul[id$="-failed"]').each(function(index) {
			$(this).removeClass('calendar-error');
			$(this).html('');
			$(this).hide();
		});

		$('input[id^="event-details"]').each(function(index) {
			$(this).removeClass('calendar-field-input-error');
		});

		$('textarea[id^="event-details"]').each(function(index) {
			$(this).removeClass('calendar-field-input-error');
		});

		/* remove edit form errors */
		$('input[id^="event-edit"]').each(function(index) {
			$(this).removeClass('calendar-field-input-error');
		});

		$('textarea[id^="event-edit"]').each(function(index) {
			$(this).removeClass('calendar-field-input-error');
		});
	};

	return objCalendar;
};
